/* unplugin-vue-components disabled */import script from "./CollectionEffect.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollectionEffect.vue?vue&type=script&lang=ts&setup=true"

import "./CollectionEffect.vue?vue&type=style&index=0&id=d07eb536&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d07eb536"]])

export default __exports__